export default __webpack_public_path__ + "static/media/engine.907c3d67.svg";